module.exports = __webpack_public_path__ + "img/search.a2fc646c.svg";